module.exports = __webpack_public_path__ + "img/login_left.6708cd31.svg";